module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container "
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container card-login-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-10 col-md-offset-1"
  }, [_c('form', {
    attrs: {
      "method": "#",
      "action": "#"
    }
  }, [_c('div', {
    staticClass: "card card-login"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/network/static/img/logo.jpg"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block\ttext-center"
  }, [(_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', [_vm._v(_vm._s(_vm.response))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "social-line"
  }, [_c('button', {
    staticClass: "loginBtn loginBtn--google",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.login('google')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tВлезте с Google акаунт\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header text-center"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Семейна образователна мрежа")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d64ebcac!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/Login.vue
// module id = 670
// module chunks = 1